<template>
  <div class="">
    <PreLoader v-if="isLoading" />

    <SectorForm
      v-if="!isLoading"
      :sector="sector"
      v-on:addOrUpdateSector="addOrUpdateSector()"
      :submitName="$t('add')"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import { STATUS } from "@/utils/constants";
import SectorForm from "@/components/settings/settingsOther/sectors/SectorForm.vue";
import Sector from "@/models/settings/settingsOther/sectors/Sector";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  mixins: [createToastMixin],
  components: {
    PreLoader,
    SectorForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      sector: new Sector(),
    };
  },
  methods: {
    async addOrUpdateSector() {
      this.isLoading = true;
      try {
        let response = await this.sector.addOrUpdateSector(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.sector.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {},
};
</script>
